export default __webpack_public_path__ + "static/media/hand.ca509c18.svg";